define.alias("shared/components/shared/wizard/slide", "settings/components/shared/wizard/slide");